/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Totalassetslabel2Inputs */

const id_sandboxes_totalassetslabel2 = /** @type {(inputs: Sandboxes_Totalassetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total asset`)
};

const ms_sandboxes_totalassetslabel2 = /** @type {(inputs: Sandboxes_Totalassetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jumlah aset`)
};

const da_sandboxes_totalassetslabel2 = /** @type {(inputs: Sandboxes_Totalassetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samlede assets`)
};

const de_sandboxes_totalassetslabel2 = /** @type {(inputs: Sandboxes_Totalassetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets insgesamt`)
};

const en_us2_sandboxes_totalassetslabel2 = /** @type {(inputs: Sandboxes_Totalassetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total assets`)
};

const es_es2_sandboxes_totalassetslabel2 = /** @type {(inputs: Sandboxes_Totalassetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de assets`)
};

const es_mx2_sandboxes_totalassetslabel2 = /** @type {(inputs: Sandboxes_Totalassetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de assets`)
};

const fil_sandboxes_totalassetslabel2 = /** @type {(inputs: Sandboxes_Totalassetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kabuuang asset`)
};

const fr_sandboxes_totalassetslabel2 = /** @type {(inputs: Sandboxes_Totalassetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total des assets`)
};

const it_sandboxes_totalassetslabel2 = /** @type {(inputs: Sandboxes_Totalassetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totale asset`)
};

const hu_sandboxes_totalassetslabel2 = /** @type {(inputs: Sandboxes_Totalassetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Összes asset`)
};

const nl_sandboxes_totalassetslabel2 = /** @type {(inputs: Sandboxes_Totalassetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totaal assets`)
};

const no_sandboxes_totalassetslabel2 = /** @type {(inputs: Sandboxes_Totalassetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totalt eiendeler`)
};

const pl_sandboxes_totalassetslabel2 = /** @type {(inputs: Sandboxes_Totalassetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Łączna liczba assetów`)
};

const pt_br2_sandboxes_totalassetslabel2 = /** @type {(inputs: Sandboxes_Totalassetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de assets`)
};

const pt_sandboxes_totalassetslabel2 = /** @type {(inputs: Sandboxes_Totalassetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de assets`)
};

const ro_sandboxes_totalassetslabel2 = /** @type {(inputs: Sandboxes_Totalassetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total asset-uri`)
};

const fi_sandboxes_totalassetslabel2 = /** @type {(inputs: Sandboxes_Totalassetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resursseja yhteensä`)
};

const sv_sandboxes_totalassetslabel2 = /** @type {(inputs: Sandboxes_Totalassetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totalt antal tillgångar`)
};

const vi_sandboxes_totalassetslabel2 = /** @type {(inputs: Sandboxes_Totalassetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng số assets`)
};

const tr_sandboxes_totalassetslabel2 = /** @type {(inputs: Sandboxes_Totalassetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toplam asset`)
};

const cs_sandboxes_totalassetslabel2 = /** @type {(inputs: Sandboxes_Totalassetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Celkem assetů`)
};

const bg_sandboxes_totalassetslabel2 = /** @type {(inputs: Sandboxes_Totalassetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общо активи`)
};

const ru_sandboxes_totalassetslabel2 = /** @type {(inputs: Sandboxes_Totalassetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Всего ассетов`)
};

const uk_sandboxes_totalassetslabel2 = /** @type {(inputs: Sandboxes_Totalassetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Усього assets`)
};

const ar_sandboxes_totalassetslabel2 = /** @type {(inputs: Sandboxes_Totalassetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إجمالي الأصول`)
};

const hi_sandboxes_totalassetslabel2 = /** @type {(inputs: Sandboxes_Totalassetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कुल एसेट्स`)
};

const th_sandboxes_totalassetslabel2 = /** @type {(inputs: Sandboxes_Totalassetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แอสเซททั้งหมด`)
};

const ja_sandboxes_totalassetslabel2 = /** @type {(inputs: Sandboxes_Totalassetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アセット総数`)
};

const zh_cn2_sandboxes_totalassetslabel2 = /** @type {(inputs: Sandboxes_Totalassetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`资源总数`)
};

const zh_hant1_sandboxes_totalassetslabel2 = /** @type {(inputs: Sandboxes_Totalassetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`資源總數`)
};

const ko_sandboxes_totalassetslabel2 = /** @type {(inputs: Sandboxes_Totalassetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`총 에셋`)
};

/**
* | output |
* | --- |
* | "Total assets" |
*
* @param {Sandboxes_Totalassetslabel2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_totalassetslabel2 = /** @type {((inputs?: Sandboxes_Totalassetslabel2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Totalassetslabel2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_totalassetslabel2(inputs)
	if (locale === "ms") return ms_sandboxes_totalassetslabel2(inputs)
	if (locale === "da") return da_sandboxes_totalassetslabel2(inputs)
	if (locale === "de") return de_sandboxes_totalassetslabel2(inputs)
	if (locale === "en-US") return en_us2_sandboxes_totalassetslabel2(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_totalassetslabel2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_totalassetslabel2(inputs)
	if (locale === "fil") return fil_sandboxes_totalassetslabel2(inputs)
	if (locale === "fr") return fr_sandboxes_totalassetslabel2(inputs)
	if (locale === "it") return it_sandboxes_totalassetslabel2(inputs)
	if (locale === "hu") return hu_sandboxes_totalassetslabel2(inputs)
	if (locale === "nl") return nl_sandboxes_totalassetslabel2(inputs)
	if (locale === "no") return no_sandboxes_totalassetslabel2(inputs)
	if (locale === "pl") return pl_sandboxes_totalassetslabel2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_totalassetslabel2(inputs)
	if (locale === "pt") return pt_sandboxes_totalassetslabel2(inputs)
	if (locale === "ro") return ro_sandboxes_totalassetslabel2(inputs)
	if (locale === "fi") return fi_sandboxes_totalassetslabel2(inputs)
	if (locale === "sv") return sv_sandboxes_totalassetslabel2(inputs)
	if (locale === "vi") return vi_sandboxes_totalassetslabel2(inputs)
	if (locale === "tr") return tr_sandboxes_totalassetslabel2(inputs)
	if (locale === "cs") return cs_sandboxes_totalassetslabel2(inputs)
	if (locale === "bg") return bg_sandboxes_totalassetslabel2(inputs)
	if (locale === "ru") return ru_sandboxes_totalassetslabel2(inputs)
	if (locale === "uk") return uk_sandboxes_totalassetslabel2(inputs)
	if (locale === "ar") return ar_sandboxes_totalassetslabel2(inputs)
	if (locale === "hi") return hi_sandboxes_totalassetslabel2(inputs)
	if (locale === "th") return th_sandboxes_totalassetslabel2(inputs)
	if (locale === "ja") return ja_sandboxes_totalassetslabel2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_totalassetslabel2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_totalassetslabel2(inputs)
	return ko_sandboxes_totalassetslabel2(inputs)
});
export { sandboxes_totalassetslabel2 as "sandboxes.totalAssetsLabel" }